module.exports = __webpack_public_path__ + "img/cid-Y.f7b7adcd.svg";